import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from '../layout/header3'
import Footer from '../layout/footer4'
// Çoklu dil desteği
import { useLanguage } from '../../hooks/useLanguage';

var bnr3 = require('./../../images/banner/bnr3.jpg');

// Banner komponenti (çoklu dil desteği ile)
const AboutBanner = () => {
  const { content } = useLanguage();
  
  return (
    <div className="dlab-bnr-inr overlay-black-middle bg-pt" style={{ backgroundImage: "url(" + bnr3 + ")" }}>
      <div className="container">
        <div className="dlab-bnr-inr-entry">
          <h1 className="text-white" style={{ fontSize: "clamp(24px, 5vw, 48px)" }}>{content.about.pageTitle}</h1>
          <div className="breadcrumb-row">
            <ul className="list-inline">
              <li><Link to={"/"}>{content.about.breadcrumb.home}</Link></li>
              <li>{content.about.breadcrumb.about}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

// Hikaye bölümü komponenti (çoklu dil desteği ile)
const AboutStory = () => {
  const { content } = useLanguage();
  
  return (
    <div className="col-lg-6 col-md-12 m-b30">
      <div className="our-story">
        <span>{content.about.story.label}</span>
        <h2 className="title" style={{fontSize: "3rem"}}>
          {content.about.story.title} <br/>
          {content.about.story.titleLine2} <br/>
          {content.about.story.titleLine3} <br/>
          <span className="text-primary">{content.about.story.since}</span>
        </h2>
        <h4 className="title">{content.about.story.subtitle}</h4>
        <p>{content.about.story.description}</p>
      </div>
    </div>
  );
};

// Hizmetler bölümü komponenti (çoklu dil desteği ile)
const AboutServices = () => {
  const { content } = useLanguage();
  
  return (
    <div className="section-full box-about-list">
      <div className="row spno">
        <div className="col-lg-6 col-md-12"> 
          <img src={require("../../images/about/pic3.jpg")} alt="" className="img-cover"/> 
        </div>
        <div className="col-lg-6 col-md-12 bg-primary">
          <div className="max-w700 m-auto p-tb50 p-lr20">
            <div className="text-white">
              <h2>
                {content.about.services.title} <br/> 
                <div>&nbsp; {content.about.services.titleAnd}</div> 
                <div>&nbsp;&nbsp;&nbsp; {content.about.services.titleBuild}</div>
              </h2>
            </div>
            {content.about.services.items.map((service, index) => (
              <div key={index} className={`icon-bx-wraper ${index < content.about.services.items.length - 1 ? 'm-b30' : ''} left`}>
                <div className="icon-md"> 
                  <Link to={"/#"} className="icon-cell text-white">
                    <i className={service.icon}></i>
                  </Link> 
                </div>
                <div className="icon-content">
                  <h4 className="dlab-tilte">{service.title}</h4>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

class About2 extends Component {
    render() {
        return (
            <>
                <Header/>
                
                <div className="page-content bg-white">
                    <AboutBanner />
                    
                    <div className="content-block">
                        <div className="section-full content-inner bg-white">
                            <div className="container">
                                <div className="row align-items-center">
                                    <AboutStory />
                                    <div className="col-lg-6 col-md-12 m-b30 our-story-thum">
                                        <img src={require("../../images/about/pic6.jpg")} className="radius-sm" alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <AboutServices />
                    </div>
                </div>
                <Footer/>
            </>
        )
    }
}
export default About2;